// extracted by mini-css-extract-plugin
export default {"modal":"hrbO4g","icon":"dXge73","title":"zaRsfQ","description":"ttHCLK","button":"ah2qKH"};